export enum PinInputErrorPosition {
  Top = 'Top',
  Bottom = 'Bottom',
}
